import { fromUnixTime } from 'date-fns';

import type { ApiISODateTimeString } from '#/api/types/ApiTypedDate';
import { useAppConfig } from '#/config/AppConfigContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchHitApplicationStatus } from '#/modules/search/components/Hit/SearchHitApplicationStatus';
import { formatRelativeToNow } from '#/utils/date';

import {
  SearchJobHitFooterContent,
  SearchJobHitFooterHolder,
  SearchJobHitFooterPublishedTimeago,
} from './SearchJobHitFooter.styled';

type Props = {
  application: {
    status: 'ACTIVE' | 'INACTIVE';
    created: ApiISODateTimeString;
  } | null;
  published: number | null;
};

export function SearchJobHitFooter({ application, published }: Props) {
  const { appConfig } = useAppConfig();
  const { i18n, locale } = useI18n();

  if (application)
    return (
      <SearchJobHitFooterHolder>
        <SearchJobHitFooterContent>
          <SearchHitApplicationStatus
            status={application.status}
            created={application.created}
          />
        </SearchJobHitFooterContent>
      </SearchJobHitFooterHolder>
    );

  if (!published) return;

  return (
    <SearchJobHitFooterHolder>
      <SearchJobHitFooterContent>
        {published && (
          <SearchJobHitFooterPublishedTimeago>
            {i18n('Posted %(postedAt)s', {
              postedAt: formatRelativeToNow({
                date: fromUnixTime(published),
                locale,
                dtOverride: appConfig.idealist.dtOverride,
              }),
            })}
          </SearchJobHitFooterPublishedTimeago>
        )}
      </SearchJobHitFooterContent>
    </SearchJobHitFooterHolder>
  );
}
